import { Box, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'

import { fontLink, fontText, fontTextHead, fontTextSmall, fullCenter, timestampToDMyyyy } from '../../../base';
import WatchLaterRoundedIcon from '@mui/icons-material/WatchLaterRounded';
import LangLink from '../../../Localization/LangLink';
import { useLanguage } from '../../../Localization/LanguageLayout';
import { theme } from '../../../Resources/Design/theme';
import { Txt } from '../../../Routes/Localized';

function parseDMY(
    dateStr,
    lang
) {
    const match = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(dateStr);
    if (!match) return null;

    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);

    if (month < 1 || month > 12) return null;

    const date = new Date(year, month - 1, day);

    if (
        date.getFullYear() !== year ||
        date.getMonth() !== month - 1 ||
        date.getDate() !== day
    ) {
        return dateStr;
    }

    if (["admin", "cs", "sk", "de", "pl", "hu", "at", "ch"].includes(String(lang).toLowerCase())) {
        return `${day}.${month}.${year}`;
    }

    return `${day}/${month}/${year}`;
}

const smallRes = {
    [theme.breakpoints.down('md')]: {
        fontSize: "12px"
    },
};

export default function Article(props) {
    const [error, setError] = useState(false);
    const { date = "", time = '4', title = '', img, hideImg = false, id, sx = {} } = props;
    const lang = useLanguage();

    useEffect(() => {
        setError(false);
    }, [img]);

    const imgProps = {
        src: img,
        loading: "eager",
    }

    const showBlank = Boolean(!img || error);

    const idProps = {
        component: LangLink,
        to: `/article/${id}`,
    }

    return (
        <Box sx={{
            display: 'flex', flexDirection: 'column', ...(id && {
                cursor: 'pointer',
                textDecoration: 'none'
            }),
            ...sx,
        }}
            {...(id ? idProps : {})}
        >
            {!hideImg && <Box component={showBlank ? 'div' : 'img'} sx={{
                width: '100%', height: '252px', minHeight: '252px', objectFit: 'cover', borderRadius: '20px',
                ...(showBlank && { bgcolor: '#E4E4E4' })
            }} onError={(e) => {
                setError(true);
            }} {...(showBlank ? {} : imgProps)} />}
            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', alignContent: 'center', mt: '10px' }}>
                <Box sx={{ bgcolor: '#0165F4', borderRadius: '50px', ...fullCenter }}>
                    <Typography sx={{ color: 'white', font: 'inter', fontWeight: 500, ...fontLink, px: '10px', py: '4px', ...smallRes }}>
                        <Txt id="23028" />
                    </Typography>
                </Box>
                <Typography sx={{ color: '#858585', font: 'inter', fontWeight: 500, ...fontLink, ml: '10px', ...smallRes }}>
                    {parseDMY(timestampToDMyyyy(date), lang)}
                </Typography>
            </Box>
            {title && <Typography sx={{ font: 'inter', fontWeight: 500, ...fontTextHead, my: '16px', color: '#011949', textAlign: 'left' }}>
                {title}
            </Typography>}

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', alignContent: 'center' }}>
                <WatchLaterRoundedIcon sx={{ color: '#0165F4' }} />
                <Typography sx={{ color: '#011949', font: 'inter', fontWeight: 500, ...fontTextSmall, ml: '10px', ...smallRes }}>
                    <Txt id="20016" value={String(time)} />
                </Typography>
            </Box>
        </Box>
    )
}
